import React, { useState, useEffect } from 'react';
import { Button, Input, Modal, Radio, Select } from 'antd';

const NewCountSheetModal = ({
  visible,
  setVisible,
  createCountSheet
}) => {

  const [inventoryName, setInventoryName] = useState('');
  const [isEmpty, setIsEmpty] = useState(false);

  useEffect(() => {
    if (visible) {
      setInventoryName('')
    }
  }, [visible]);

  return (
    <Modal
      title='Count Sheet'
      open={visible}
      onCancel={() => setVisible(false)}
      closable
      width={400}
      footer={[
        <Button
          key="cancel"
          className='Deactivate-Button'
          onClick={() => setVisible(false)}
        >
          Cancel
        </Button>,
        <Button
          key="add"
          onClick={() => {
            if (inventoryName.trim().length === 0) {
              setIsEmpty(true);
              return;
            }

            createCountSheet(inventoryName.trim());
          }}
          style={{ backgroundColor: '' }}
          disabled={inventoryName === ''}
          className='printButton2'
        >
          Create
        </Button>
      ]}
    >
      <div>
        <div>
          <label style={{ fontSize: '15px', position: 'relative', top: '-2px' }} className='label'>Name : </label>
          <div>
            <Input
              size='medium'
              value={inventoryName}
              onChange={e => {
                setIsEmpty(false);
                setInventoryName(e.target.value);
              }}
              placeholder='Enter Your Count Sheet Name'
              style={{ width: '100%' }}
            />
            {isEmpty && (
              <p style={{ color: 'red', fontSize: 12 }}>Please enter valid countsheet name</p>
            )}
          </div>
        </div>

      </div>

    </Modal>
  );
};

export default NewCountSheetModal;
